import { TradingService } from './../../../services/common/trading-service.service';
import { Component, ViewChild, Input, SimpleChanges, Output, EventEmitter, Optional, Inject } from '@angular/core';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { TradingConstants } from '../../../utils/trading-constants';
import { TransactionType, TypeAhead, TypeAheadSecurityType } from '../../../models/common/trading-common.model';
import { Subscription } from 'rxjs';
import { Holdings, TradingEntitlements } from '../../../models';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
@Component({
  selector: 'symbol-search-auto-complete',
  exportAs: 'symbolSearch',
  templateUrl: './symbol-search-auto-complete.component.html',
  styleUrls: ['./symbol-search-auto-complete.component.css']
})
export class SymbolSearchAutoCompleteComponent {
  Number: any;
  symbolQueryArr: TypeAhead[] = [];
  symbolForSellArr: Holdings[] = [];
  showSellView: boolean = false;
  showBuyView: boolean = false;
  showLoadWarning: boolean = false;
  isBuyToCover: boolean = false;
  alertMsg: string;
  getSymbolQueryHttpSub: Subscription;
  holdingLoadCompleteSubscription: Subscription;
  isEquityTrade: boolean = false;
  flagPrefix: string = 'flag-icon-';
  titleText: string;
  classNameLargeSell: string = '';
  language: string = '';


  @Input() symQueryType: string;
  @Input() symbol: any;
  @Input() platform: string;
  @Input() tradeType: TypeAheadSecurityType;
  @Input() acctNum: string;
  @Input() transactionType: string;
  @Input() excludeNonUSSymbols: boolean;

  @Input() tradingEntitlements: TradingEntitlements;
  @Input() isBankCustodyAcct: boolean;

  @Output() optionSelected: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() closed: EventEmitter<null> = new EventEmitter<null>();
  @Output() sellSymListLoaded: EventEmitter<null> = new EventEmitter<null>();

  @ViewChild(MatAutocomplete) autocomplete: MatAutocomplete;

  get isOpen() {
    return this.autocomplete._isOpen;
  }

  get isDisplayed() {
    return this.autocomplete.showPanel;
  }

  constructor(private tradingService: TradingService, @Optional() @Inject('AppSettings') appSettings: any
) {
    this.Number = Number;
    if (appSettings) {
      this.language = appSettings.language;
      if (this.language === 'es') {
         registerLocaleData( es );
      }
  }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // FOr sell View symbol return select row object do the would take right object foe sell view
    if (changes?.symbol && this.showSellView && changes.symbol.previousValue && changes.symbol.currentValue) {
      changes.symbol.previousValue = changes.symbol.previousValue.symbol;
      changes.symbol.currentValue = changes.symbol.currentValue.symbol;
    }
    if (changes?.symbol && changes.symbol.previousValue && changes.symbol.currentValue
          && changes.symbol.previousValue.toUpperCase() === changes.symbol.currentValue.toUpperCase()) {
      return;
    }

    this.alertMsg = '';
    if (!this.symbol) {
      this.symbolQueryArr = [];
      this.symbolForSellArr = [];
    }

    if (this.transactionType === TransactionType.BUY_TO_COVER) {
      this.isBuyToCover = true;
    } else {
      this.isBuyToCover = false;
    }
    this.showBuyView = (this.symQueryType === TradingConstants.BUY_VIEW) ? true : false;
    this.showSellView = (this.symQueryType === TradingConstants.SELL_VIEW) ? true : false;
    this.isEquityTrade = (this.tradeType === TypeAheadSecurityType.EQUITY) ? true : false;
    this.processSymbolSearch();
    
    if (window.innerWidth > 800) {
      this.classNameLargeSell = 'tr-SymbolSearchAutoComplete_Large';
    }
  }

 private processSymbolSearch(): void {
  if (!!this.acctNum && !!this.platform && !!this.tradeType) {
    if (this.showBuyView && !!this.symbol) {
      this.getSymbolQueryHttpSub && this.getSymbolQueryHttpSub.unsubscribe();   // cancel ongoing http call just in case
      this.getSymbolQueryHttpSub = this.tradingService.getSymbolQuery(this.platform, this.acctNum, this.symbol, this.tradeType, this.excludeNonUSSymbols).subscribe(
        (data) => this.handleSymbolQueryResp(data),
        (error) => this.handleError(error)
      );
    }

    if (this.showSellView) {
      this.showLoadWarning = this.tradingService.holdingsLoadInProgress;

      if ( this.showLoadWarning && !this.holdingLoadCompleteSubscription ) {
        // make sure we only subscribe once when showing the loading warning
        this.holdingLoadCompleteSubscription = this.tradingService.holdingLoadCompleteSubject$.subscribe((data: any) => this.handleHoldingLoadCompletion());
      }

      let secTypes: Array<TypeAheadSecurityType> = new Array<TypeAheadSecurityType>();
      secTypes.push(this.tradeType);
      if (this.isEquityTrade){
        secTypes.push(TypeAheadSecurityType.UNIT);
      }

      this.tradingService.getSymbolForSell(this.platform, this.acctNum, this.symbol, secTypes, this.transactionType).subscribe(
        (data) => this.handleSymbolForSellResp(data),
        (error) => this.handlePositionError(error)
      );
    }
}
 }
  handleSymbolQueryResp(data) {
    if (data.errorCode === 0 && data.response) {
      this.symbolQueryArr = data.response;
      this.updateBuySymbolCountry();
    } else {
      console.log('error server resp in tradingService.getSymbolQuery:', data);
    }

    if (!!this.symbol && this.symbol.length > 2 && (!this.symbolQueryArr || this.symbolQueryArr.length === 0)) {
      this.alertMsg = 'SYMBOL_SELECTION.ERROR.NO_SYMBOLS';
    }
  }

  handleSymbolForSellResp(data) {
    if (data.errorCode === 0 && data.response) {
      this.symbolForSellArr = this.sortBySymbol(this.filterOutEmptySymbolRecords(data.response));
      if (this.isEquityTrade) {
        this.updateSellSymbolCountry();
      }
    } else {
      console.log('error server resp in tradingService.getSymbolQuery:', data);
    }

    if ( !this.tradingService.holdingsLoadInProgress ) {
      if ( !this.symbolForSellArr || this.symbolForSellArr.length === 0 ) {
        if ( !this.symbol || this.symbol === '' ) {
          this.setAlertMsg();
        } else {
          this.alertMsg = 'SYMBOL_SELECTION.ERROR.NO_SECURITY';
        }
      }
      this.sellSymListLoaded.emit();
    }
  }

  setAlertMsg() {
    if (this.isEquityTrade) {
      if (this.isBuyToCover) {
        this.alertMsg = 'SYMBOL_SELECTION.ERROR.NO_HOLDINGS_BUY_TO_COVER';
      } else {
        this.alertMsg = 'SYMBOL_SELECTION.ERROR.NO_HOLDINGS';
      }
    } else {
      this.alertMsg = 'SYMBOL_SELECTION.ERROR.NO_HOLDINGS_OPTIONS';
    }
  }

  handleHoldingLoadCompletion() {
    // Have to check if load is still in progress, because the
    // act of subscribing immediately calls this function
    if ( this.tradingService.holdingsLoadInProgress ) {
      return;
    }

    this.showLoadWarning = false;

    if ( this.isOpen && this.showSellView ) {
      // Since it's still open, we want to visibly refresh the display
      // and filter based on what has been entered so far
      this.ngOnChanges({
        symbol: {
          firstChange: null,
          previousValue: !!this.symbol ? this.symbol.substring(0, this.symbol.length - 1) : null,
          currentValue: !!this.symbol ? this.symbol : '',
          isFirstChange: () => { return false; }
        }
      });
    } else if ( !this.isOpen && this.showSellView ) {
      let secTypes: Array<TypeAheadSecurityType> = new Array<TypeAheadSecurityType>();
      secTypes.push(this.tradeType);
      if (this.isEquityTrade) {
        secTypes.push(TypeAheadSecurityType.UNIT);
      }
      // When the autocomplete is already closed (e.g., user tabbed
      // away), just refresh the sell symbol list so it's available
      // to any parent components that might need it.
      this.tradingService.getSymbolForSell(this.platform, this.acctNum, this.symbol, secTypes, this.transactionType).subscribe(
        (data) => this.handleSymbolForSellResp(data),
        (error) => this.handlePositionError(error)
      );
    }
  }

  resetMatOptionData() {
    this.symbolQueryArr = null;
    this.symbolForSellArr = null;
    this.alertMsg = '';
  }

  filterOutEmptySymbolRecords(items): any {
    return items.filter((item) => {
      let isValidRec: boolean = !!((item.symbol || '').trim());

      if (item.security && item.security.securityIdType) {  // if securityIdType is not 'SYMBOL', the item.symbol may not empty but it is NOT "symbol"
        isValidRec = (item.security.securityIdType.toUpperCase() === 'SYMBOL');
      }

      return isValidRec;
    });
  }

  // Sort symbol query response for buy/sell
  sortBySymbol(response): any {
    return response.sort((item1, item2) => {
          if (item1.symbol > item2.symbol) {
            return 1;
          } else if (item1.symbol < item2.symbol) {
            return -1;
          } else {
            return 0;
          }
      });
  }
  handleError(error) {
    console.log('system error in tradingService.getSymbolQuery:', error);
    this.alertMsg = 'errors.SYSTEM_ERROR_MESSAGE';
  }

  handlePositionError(error) {
    this.alertMsg = 'SYMBOL_SELECTION.ERROR.NOT_ABLE_TO_RETRIVE_HOLDINGS';
  }

  optionClosed() {
    this.closed.emit();
  }

  selected(val) {
    this.optionSelected.emit(val);
  }

  updateSellSymbolCountry() {
    if (this.symbolForSellArr !== null && this.symbolForSellArr.length > 0) {
      for (let symInfo of this.symbolForSellArr) {
        if (symInfo.security.symbol !== null && symInfo.security.symbol.indexOf(':') > 0) {
          symInfo.flagClass = this.flagPrefix + symInfo.symbol.slice(symInfo.symbol.indexOf(':') + 1).toLowerCase();
        } else {
          symInfo.flagClass = this.flagPrefix + 'us';
        }
      }
    }
  }

  updateBuySymbolCountry() {
    if (this.symbolQueryArr !== null && this.symbolQueryArr.length > 0) {
      for (let symInfo of this.symbolQueryArr) {
        if (!!symInfo.symbol && symInfo.symbol.indexOf(':') > 0) {
          symInfo.flagClass = this.flagPrefix + symInfo.symbol.slice(symInfo.symbol.indexOf(':') + 1).toLowerCase();
        } else {
          symInfo.flagClass = this.flagPrefix + 'us';
        }
      }
    }
  }

  ngOnDestroy(): void {
    if ( this.holdingLoadCompleteSubscription ) {
        this.holdingLoadCompleteSubscription.unsubscribe();
    }
  }
}
